import PropTypes from 'prop-types'
import { Col, Row, Image as Img, Button } from 'antd'
import { StyledSuperCard } from './styles'

export const DefaultList = ({ details, k, redirectLink }) => {
  return (
    <StyledSuperCard bgimage={details.bgImage}>
      <Row key={k} className='center-vh text-center pizza-card'>
        <Col span={14} className='sc-img'>
          <Img src={details.cardImg} alt='' width={200} height={140} preview={false} />
        </Col>
        <Col span={20}>
          <h3 style={{ color: '#fff', textAlign: 'center' }}>{details.text.card}</h3>
          <div className='mt-2' />
          <p style={{ color: '#fff', textAlign: 'center' }}>{details.text.number}</p>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'center', alignItems: 'center' }}>
            <Img src='/images/supercard/checked.png' preview={false} width={16} />
            <div className='ml-2' style={{ fontSize: '17px', color: 'white', fontWeight: 'bold' }}>
              {details.text.status}
            </div>
          </div>
        </Col>
      </Row>
      <Row className='text-center pizza-card-footer'>
        <Col span={12} offset={1} className='center-vh'>
          <div className='text-left'>
            <h4 style={{ fontSize: 28, fontWeight: 'bold', color: 'var(--orange-peel)' }}>{details.text.points || 0} Superpoints</h4>
            <p style={{ fontSize: 10 }}>{details.text.statusDescription}</p>
          </div>
        </Col>
        <Col span={8} offset={1} className='mt-3'>
          <Row>
            <Col span={18} offset={3} className='center-vh'>
              <Button style={{ maxWidth: 130, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }} className='default-btn-size' type='primary' onClick={redirectLink}>
                <Img src='/images/supercard_v2/icons/birthday/birthday-white.svg' preview={false} width={17} />
                <p style={{ fontSize: 10, flexWrap: 'nowrap', textAlign: 'left', fontWeight: 'bold' }}>View my Supercard <br /> Benefits</p>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledSuperCard>
  )
}

DefaultList.propTypes = {
  k: PropTypes.any,
  details: PropTypes.object,
  redirectLink: PropTypes.any
}
